import http from "../utils/http";
export default{
    waybillPage:function(data,fun){
        http.get("/business/waybill-page",data,fun)
    }, 
    waybillStatisticsPage:function(data,fun){
        http.get("/report/waybill-statistics-page",data,fun)
    },
    appuserStatisticsPage:function(data,fun){
        http.get("/report/appuser-statistics-page",data,fun)
    }, 
    wxQueryPage:function(data,fun){
        http.post("/st-wx-message-record/queryPage",data,fun)
    }, 
    
}